import React, { useEffect, useState } from 'react';
import { ReactNode } from 'react';
import { useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../app/hooks';
import { RootState } from '../app/store';
import { useSidebar } from '../context/SidebarContext';
import Sidebar from './Sidebar';



interface UserDetails {
  id: number;
}

interface DashboardLayoutProps {
  children: ReactNode;
  userDetails: UserDetails;
}


const ApplicationLayout: React.FC<DashboardLayoutProps> = ({ children }) => {
//Filter all numbers that are divisible by 3 find approach not code


  const { baseId } = useParams<{ baseId: string }>();
  const [userDetails, setUserDetails] = useState<any>(null);
  const bases = useAppSelector((state: RootState) => state?.base?.data?.data?.bases);
  const dispatch = useAppDispatch();

  const isAuthenticated = useAppSelector((state: RootState) => state);
  const [baseSwitchMemberDetails, setBaseSwitchMemberDetails] = useState<any>(null);
  const { verticleSidebar, setVerticleSidebar } = useSidebar();

  useEffect(() => {
    if (bases && bases.length > 0) {
      const matchedBase = bases.find((base: { id: number }) => base.id.toString() === baseId);
      if (matchedBase) {
        setUserDetails(matchedBase);
      }
    }
    else if (baseId) {
      setUserDetails(baseId);
    }
    else {
      setUserDetails(null);

    }
  }, [baseId, bases]);

  // base memeber
  

  return (
    <div className="h-[calc(100vh_-_4rem)]">
      <Sidebar userDetails={userDetails} />

      <div 
      
      className={`${verticleSidebar ? 'lg:pl-[225px]' : 'lg:pl-[59px]'} transition-all duration-300`}

      >
        <main className='p-0'>
          <div className='w-full'>
            {children}
          </div>
        </main>
      </div>
    </div>
  );
};

export default ApplicationLayout;
